export const WEEKDAYS_SHORT = {
	sv: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
	fi: ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La']
};

export const MONTHS = {
	fi: [
		'Tammikuu',
		'Helmikuu',
		'Maaliskuu',
		'Huhtikuu',
		'Toukokuu',
		'Kesäkuu',
		'Heinäkuu',
		'Elokuu',
		'Syyskuu',
		'Lokakuu',
		'Marraskuu',
		'Joulukuu'
	],
	sv: [
		'Januari',
		'Februari',
		'Mars',
		'April',
		'Maj',
		'Juni',
		'Juli',
		'Augusti',
		'September',
		'Oktober',
		'November',
		'December'
	]
};

export const WEEKDAYS_LONG = {
	fi: ['Sunnuntai', 'Maanantai', 'Tiistai', 'Keskiviikko', 'Torstai', 'Perjantai', 'Lauantai'],
	sv: ['Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag', 'Söndag']
};

export const FIRST_DAY_OF_WEEK = {
	fi: 1,
	sv: 1
};

// Translate aria-labels
export const LABELS = {
	fi: { nextMonth: 'Seuraava kuukausi', previousMonth: 'Edeltävä kuukausi' },
	sv: { nextMonth: 'Prossimo mese', previousMonth: 'Mese precedente' }
};
